export default class BlockTextMedia {
	static init() {

		let blocks = document.querySelectorAll('.block-text-media');

		blocks.forEach( (block) => {
			let swipers = block.querySelectorAll('.swiper');

			swipers.forEach((swiper) => {
				const prev = block.querySelector(".swiper-custom-button-prev");
				const next = block.querySelector(".swiper-custom-button-next");
				const pagination = block.querySelector(".swiper-custom-pagination");
				new Swiper(swiper, {
					slidesPerView: 1,
					grabCursor: true,
					navigation: {
						prevEl: prev,
						nextEl: next,
					},
					pagination: {
						el: pagination,
						type: 'bullets'
					}
				});
			});

		});
	}
}
